import { BadgeSlotProps } from './types'
import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import Typography from '@/features/ui/typography'
import { ComponentType, FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface TabProps {
    children: string
    active?: boolean
    Badge?: ComponentType<BadgeSlotProps>
}

const Tab: FC<TabProps> = ({ children, active = false, Badge }) => {
    const { styles } = useStyles(stylesheet, { active })

    const withBadge = !!Badge

    return (
        <View style={[styles.container, withBadge && { paddingLeft: 6 }]}>
            {withBadge && <Badge active={active} />}
            <Typography.Menu size="small" style={styles.label}>
                {children}
            </Typography.Menu>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        borderRadius: 16,
        paddingHorizontal: 16,
        paddingVertical: 6,
        variants: {
            active: {
                true: {
                    backgroundColor: ColorEnum.BRICK_600,
                },
                false: {
                    backgroundColor: ColorEnum.WHITE,
                },
            },
        },
    },
    label: {
        fontFamily: FontEnum.SatoshiBold,
        fontSize: 12,
        lineHeight: 15.6,
        overflow: 'hidden',
        textTransform: 'uppercase',
        variants: {
            active: {
                true: {
                    color: ColorEnum.WHITE,
                },
                false: {
                    color: ColorEnum.BRICK_600,
                },
            },
        },
    },
})

export default Tab
